import React from 'react';
import { Form } from 'react-bootstrap';

interface TextareaInputProps {
    id: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
    rows?: number;
    placeholder?: string;
    required?: boolean;
    hasError?: boolean;
    className?: string;
}

export const TextareaInput: React.FC<TextareaInputProps> = ({
    id,
    name,
    value,
    onChange,
    onBlur,
    rows = 3,
    placeholder,
    required = false,
    hasError = false,
    className = ''
}) => {
    return (
        <Form.Control
            as="textarea"
            isInvalid={hasError}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            rows={rows}
            placeholder={placeholder}
            required={required}
            className={className}
        />
    );
};
